import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import api from "../../../api/api";

import PasswordInput from "../../../components/PasswordInput";
import TextInput from "../../../components/TextInput";
import { API_ENDPOINTS } from "../../../config/api";

import "./css/loginModal.css";


import { logger } from '../../../utils/logger';
export default function LoginModal() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { login } = useAuth();

  type LoginResponseOk = {
    user: { user_id: number; full_name: string; email: string };
    role?: { role_id: number; label: string | null };
    company?: { company_id: number; name: string; trading_name: string; status: string };
    redirectUrl?: string;
  };

  type LoginResponseErr = {
    error?: string;
  };

  const handleLogin = async () => {
    setError("");

    try {
      const response = await api.post<LoginResponseOk | LoginResponseErr>(
        API_ENDPOINTS.login,
        { email, password },
      );

      const data = response.data;

      if (response.status >= 200 && response.status < 300) {
        logger.debug("Login successful!", data);
        const userData = (data as LoginResponseOk).user;
        const roleData = (data as LoginResponseOk).role;
        const companyData = (data as LoginResponseOk).company;
        login({
          ...userData,
          roleid: roleData?.role_id ?? null,
          role: roleData?.label ?? "",
          company: companyData,
        });

        // Use redirectUrl from backend if provided
        const redirectUrl = (data as LoginResponseOk).redirectUrl;
        if (redirectUrl && redirectUrl !== '/') {
          navigate(redirectUrl);
        } else {
          setError("Login successful");
          setTimeout(() => setError(""), 3000);
        }
      } else {
        setError((data as LoginResponseErr).error || "Invalid email or password");
        setTimeout(() => setError(""), 5000);
      }
    } catch (err: any) {
      console.error("Login error:", err);
      
      // Axios automatically parses error responses
      if (err.response?.data?.error) {
        setError(err.response.data.error);
      } else if (err.response?.data) {
        setError(err.response.data.message || err.response.data.error || "Invalid email or password");
      } else {
        setError("Something went wrong. Try again.");
      }
      setTimeout(() => setError(""), 5000);
    }
  };

  return (
    <div className="pis-loginScreen">
      <div className="pis-loginCard" role="dialog" aria-label="Login">
        <div className="pis-brand">
          <div className="pis-brandIcon" aria-hidden="true">
            <img src="/PayItSmart.svg" alt="PayItSmart" className="pis-brandIconImg" />
          </div>
          <div className="pis-subtitle">
            Enter your details to access your
            <br />
            PayItSmart dashboard.
          </div>
        </div>

        <form
          className="pis-form"
          onSubmit={(e) => {
            e.preventDefault();
            handleLogin();
          }}
        >
          <TextInput
            id="email"
            label="Email address"
            type="email"
            placeholder="name@company.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
          />

          <PasswordInput
            id="password"
            label="Password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />

          {error && <div className="pis-errorMessage">{error}</div>}

          <button type="submit" className="pis-loginBtn">
            Log In
          </button>
        </form>

        <div className="pis-divider" />

        <div className="pis-footer">
          <span className="pis-footerText">Don't have an account?</span>
          <button type="button" className="pis-linkBtn" onClick={() => navigate("/register")}>
            Register here
          </button>
        </div>
      </div>
    </div>
  );
}
